export default __webpack_public_path__ + "static/media/BackgroundLeft.8d665362.jpg";